import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useState} from 'react';
import DroppableList from '../DraggingWrappers/DroppableList';
import styles from "../Merging.module.css";
import Condition from "../../Condition/Condition";
import PulsingDivWrapper from "../DraggingWrappers/PulsingDivWrapper";


const ConditionsMergingDisplay = forwardRef (({ patternSelected, fromPattern, toPattern }, ref) => {
    const [fromList, setFromList] = useState([]);
    const [toList, setToList] = useState([]);
    const [draggingTo, setDraggingTo] = useState(false)
    const [draggingFrom, setDraggingFrom] = useState(false)

    const existsInToList = useCallback((item) => {
        return (
            Array.isArray(toList) &&
            item && item.condition &&
            toList.some(f => +item.condition.condition_id === +f.condition.condition_id)
        );
    }, [toList]);

    const existsInFromList = useCallback((item) => {
        return (
            Array.isArray(fromList) &&
            item && item.condition &&
            fromList.some(f => +item.condition.condition_id === +f.condition.condition_id)
        );
    }, [fromList]);

    useEffect(() => {
        if (fromPattern && fromPattern.conditions) {
            setFromList(fromPattern.conditions.map((condition, index) => {
                const id = condition.condition_id + " patternId-" + fromPattern.pattern_id
                const isGrayedOut = existsInToList({ condition: condition });
                return {
                    id,
                    condition,
                    content: <div className={isGrayedOut ? styles.GrayedOut : ''}><Condition condition={condition} extraStyle={`${styles.FromColor} ${styles.FromTextColor}`}/></div>,
                    index,
                    disableDrag: isGrayedOut
                }
            }))
        }
    }, [fromPattern, patternSelected, existsInToList]);

    useEffect(() => {
        if (toPattern && toPattern.conditions) {
            setToList(toPattern.conditions.map((condition, index) => {
                const id = condition.condition_id + " patternId-" + toPattern.pattern_id
                return {
                    id,
                    condition,
                    content: <Condition condition={condition}/>,
                    index,
                    disableDrag: true
                }
            }))
        }
    }, [toPattern, patternSelected]);

    const moveItemBetweenLists = (item, start, destination) => {
        if (start === destination) {
            return;
        }
        if (start === 'fromList' && destination === 'toList' && !existsInToList(item)) {
            let newItem = {...item}
            newItem.content = <Condition condition={item.condition} extraStyle={`${styles.FromColor} ${styles.FromTextColor}`}/>
            setToList(prev => [newItem, ...prev]); // Add to target
        } else if (start === 'toList' && destination === 'fromList' && existsInFromList(item)) {
            setToList(prev => prev.filter(i => +i.condition.condition_id !== +item.condition.condition_id))
        }
    };

    useImperativeHandle(ref, () => ({
        getList: () => {
            return toList.map(item => item.condition);  // Return the current state of toList
        }
    }));

    return (
        <div className={styles.Container}>
            {/*This style is kinda cursed but it will likely not be necessary once conditions uses pattern component*/}
            <div className={styles.SplitCols} style={{maxWidth: '50%', marginRight: '-2.5%', paddingRight: '10px'}}>
                <h3>Conditions:</h3>
                <PulsingDivWrapper active={draggingFrom}>
                    <DroppableList
                        list={toList}
                        setList={setToList}
                        itemType={'CONDITIONS'}
                        targetListName="toList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        setDragging={setDraggingTo}
                    />
                </PulsingDivWrapper>
            </div>
            <div className={styles.Separator}></div>
            <div className={styles.SplitCols} style={{maxWidth: '50%', marginLeft: '-2.5%', paddingLeft: '10px'}}>
                <h3>Conditions:</h3>
                <PulsingDivWrapper active={draggingTo}>
                    <DroppableList
                        list={fromList}
                        setList={setFromList}
                        itemType={'CONDITIONS'}
                        targetListName="fromList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        setDragging={setDraggingFrom}
                    />
                </PulsingDivWrapper>
            </div>
        </div>
    )
});

export default ConditionsMergingDisplay;
